import { Directive, DoCheck, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { AuthService } from '../core/auth.service';

@Directive({ selector: '[appAuthorize]'})
export class AuthorizeDirective implements DoCheck {
  @Input() appAuthorize: any;
  private hasView = false;

  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private auth: AuthService) { }

  ngDoCheck() {
    if (this.isAuthorized && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!this.isAuthorized && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private get isAuthorized() {
    if (this.appAuthorize === undefined) {
      return false;
    }

    if (!Array.isArray(this.appAuthorize)) {
      return this.hasAuthorized(this.appAuthorize);
    }

    return this.appAuthorize
      .filter(v => this.hasAuthorized(v.trim()))
      .length > 0;
  }

  private hasAuthorized(authorized: string) {
    if (authorized === 'isAuthenticated') {
      return this.auth.isAuthenticated;
    }

    if (authorized === 'isInstructor') {
      return this.auth.isInstructor;
    }

    if (authorized === 'isContentManager') {
      return this.auth.isContentManager;
    }

    if (authorized && authorized.startsWith('!')) {
      return this.auth.uid && !(authorized.slice(1) === this.auth.uid);
    }

    return this.auth.uid && (authorized === this.auth.uid);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/authorize.directive.ts